// this is an autogenerated file from App/Account/Content/Settings/Content/Charges/AddAction/Add/Content/InsuranceCode/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_Charges_AddAction_Add_Content_InsuranceCode{
  vaxiom_insurance_codes(
    where: { deleted: { _eq: false } }
    order_by: { code: asc_nulls_last, title: asc_nulls_last }
  ) {
    id
    code
    title
  }
}

`